module.exports = __webpack_public_path__ + "img/gavel.689ea13f.jpg";